import { get, orderBy, padStart } from 'lodash';
import React, { useContext, useMemo, Fragment } from 'react';

import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { goFullScreen } from '../util/go_full_screen';

import { LeaderboardContext } from '../context';
import { PageWrapper } from '../styles';

function divmod(x, y) {
  return [Math.floor(x / y), x % y];
}

function displayScore(score) {
  let milliseconds = score,
    minutes,
    seconds;

  [minutes, milliseconds] = divmod(milliseconds, 1000 * 60);
  [seconds, milliseconds] = divmod(milliseconds, 1000);

  const minDisplay = padStart(String(minutes), 2, '0');
  const secDisplay = padStart(String(seconds), 2, '0');
  const milDisplay = padStart(String(milliseconds), 3, '0');

  return `${minDisplay}'${secDisplay}"${milDisplay}`;
}

const clientEntries = [
  {
    id: 'clientEntry-01',
    name: 'Bob McMurray',
    avatarSrc: require('../assets/bob_mcmurray.png'),
    score: '02\'04"021',
  },
  {
    id: 'clientEntry-02',
    name: 'Sebastien Ogier',
    avatarSrc: require('../assets/sebastien_ogier.png'),
    score: '02\'05"678',
  },
];

function TopEntriesPage({ topEntries }) {
  console.log('TopEntriesPage', { topEntries });

  const theme = useTheme();
  // const { attributes: leaderboard } = useContext(LeaderboardContext);

  const sortedTopEntries = useMemo(
    () =>
      true // leaderboard.sorted
        ? orderBy(topEntries, 'rank', 'asc')
        : orderBy(topEntries, 'score', 'desc'),
    [topEntries]
  );

  return (
    <PageWrapper>
      <Header>
        {theme.logo && <img onClick={goFullScreen} src={theme.logo} />}
      </Header>

      <EntriesGrid>
        {clientEntries.map(entry => (
          <>
            <Avatar key={`entry-${entry.id}-avatar`} src={entry.avatarSrc} />
            <Text key={`entry-${entry.id}-name`}>{entry.name}</Text>
            <Text key={`entry-${entry.id}-score`}>{entry.score}</Text>
            <Text key={`entry-${entry.id}-rank`}>TGR</Text>
          </>
        ))}

        <Subtitle key="entries-subtitle">Current Daily Leaders</Subtitle>

        {sortedTopEntries.map(({ id, rank, score, user = {} }) => {
          const avatarSrc = get(user, 'links.avatar');
          return (
            <>
              <Avatar
                key={`entry-${id}-avatar`}
                src={avatarSrc ? avatarSrc : null}
              />
              <Text key={`entry-${id}-name`}>
                {user.attributes.first_name} {user.attributes.last_name}
              </Text>
              <Text key={`entry-${id}-score`}>{displayScore(score / 100)}</Text>
              <RankText key={`entry-${id}-rank`} rank={rank} />
            </>
          );
        })}
      </EntriesGrid>
    </PageWrapper>
  );
}

function RankText({ rank }) {
  switch (rank) {
    case 1:
      return (
        <Text>
          1<small>st</small>
        </Text>
      );
    case 2:
      return (
        <Text>
          2<small>nd</small>
        </Text>
      );
    case 3:
      return (
        <Text>
          3<small>rd</small>
        </Text>
      );
    default:
      return '';
  }
}

const Subtitle = styled.h2`
  grid-column: 1 / -1;

  border-top: 4pt solid white;

  margin-top: 30pt;
  margin-left: -80pt;
  margin-right: -80pt;
  margin-bottom: 0;

  padding-top: 30pt;
  padding-left: 80pt;
  padding-right: 80pt;
  padding-bottom: 30pt;

  color: #e83330;
  font-size: 30pt;
  text-transform: uppercase;
`;

const Avatar = styled.img`
  height: 40pt;
  width: 40pt;

  border-radius: 9999px;

  margin-right: 40pt;
`;

const Text = styled.p`
  font-size: 24pt;
  text-transform: uppercase;
`;

const Header = styled.div`
  label: entries-header-box;

  display: grid;

  text-align: center;

  align-items: center;
  justify-content: center;

  background-color: ${props => props.theme.foregroundColor};
  color: ${props => props.theme.foregroundTextColor};

  height: 240px;
  width: 100%;
`;

const EntriesGrid = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr 1fr min-content;

  align-items: center;
  width: 1140pt;

  margin-top: 15pt;
  margin-left: auto;
  margin-right: auto;

  padding-left: 80px;
  padding-right: 80px;
`;

export default TopEntriesPage;
